import { render } from "./upgrade_restore.vue?vue&type=template&id=b35faaa2"
import script from "./upgrade_restore.vue?vue&type=script&lang=js"
export * from "./upgrade_restore.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__